'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getReferrer = exports.setReferrer = undefined;

var _localStorage = require('../../../utils/services/localStorage/localStorage');

var _localStorage2 = _interopRequireDefault(_localStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setReferrer = exports.setReferrer = function setReferrer(referrer) {
  return _localStorage2.default.setItem('milanote.referrer', referrer);
};

var getReferrer = exports.getReferrer = function getReferrer() {
  return _localStorage2.default.getItem('milanote.referrer');
};


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/referral/referrerService.js
// module id = 755
// module chunks = 0